import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-table-gantt',
  templateUrl: './table-gantt.component.html',
  styleUrls: ['./table-gantt.component.scss']
})
export class TableGanttComponent implements OnInit {
  @Input() structure = null;
  @Input() index: number;
  @Input() indexTable: number;
  @Input() group: any;
  @Input() oldBdField: any;
  @Input() oldValue: any;
  @Input() tab: any;
  @Input() idFa: any;

  constructor() { }

  ngOnInit(): void {
  }

}
